angular.module('app.api').factory('ReferralApi', [
  'api',
  function ReferralApi(api) {
    const referralApi = {
      getReferralsListing: async payload => {
        return api.get('listings/referral', {params: payload})
      },
      getAllReferralsByReferralCode: async referralCode => {
        return api.get(`referrals/${referralCode}`)
      },
    }
    return referralApi
  },
])



// WEBPACK FOOTER //
// ./scripts/admin-panel/referral-listing/referral-listing.api.js